import styled from 'styled-components';
import { IconYaGPTLoading } from '../../icon/IconYaGPTLoading';
import { Button } from '../../input/Button';

export const SubmitButton = styled(Button)
    .withConfig({ displayName: 'SubmitButton' })
    .attrs((props) => ({
        width: '100%',
        height: '46px',
        size: 'm',
        ...props,
    }))`
    margin-top: auto;
`;

export const GPTImage = styled(IconYaGPTLoading)
    .withConfig({ displayName: 'GPTImage' })
    .attrs((props) => ({
        ...props,
        size: 24,
    }))``;
